module.exports = __webpack_public_path__ + "static/media/2.525d2f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/code/2.jpg
// module id = 493
// module chunks = 0